<template>
  <main>
    <div class="container-fluid">
      <div
        class="page-header min-height-300 bg-addiuva"
        style="
          margin-right: -24px;
          margin-left: -34%;
        "
      >
        <span class="mask bg-gradient-addiuva opacity-6"></span>
      </div>
      <div class="card shadow-lg mt-n12">

      </div>
    </div>
    <div class="py-4 container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <h4 class="text-center">Información Personal</h4>
              <div class="row mt-4">
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label">Nombre de Usuario</label>
                  <input class="form-control" type="text" v-model="user.persona.email" disabled />
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label">Correo Electrónico</label>
                  <input class="form-control" type="email" v-model="user.persona.email" disabled/>
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label">Nombres</label>
                  <input class="form-control" type="text" v-model="user.persona.nombres"/>
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label">Apellidos</label>
                  <input class="form-control" type="text" v-model="user.persona.apellidos"/>
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label">Rol</label>
                  <input class="form-control" type="text" v-model="user.nombre_rol" disabled/>
                </div>
                <div class="col-md-6">
                  <label for="example-text-input" class="form-control-label">Agencia</label>
                  <input class="form-control" type="text" v-model="user.nombre_agencia"/>
                </div>
              </div>
              <hr class="horizontal dark" />
              <p class="text-uppercase text-sm">Datos Adicionales</p>
              <div class="row">
                <div class="col-md-4">
                  <label for="example-text-input" class="form-control-label">Documento de Identidad</label>
                  <input class="form-control" type="text" v-model="user.persona.numero_documento"/>
                </div>
                <div class="col-md-4">
                  <label for="example-text-input" class="form-control-label">Fecha de Nacimiemto</label>
                  <datepicker
                    v-model="user.persona.fecha_nacimiento"
                    :="basicConfigDatePicker"
                    name="user.persona.fecha_nacimiento"
                  ></datepicker>
                </div>
                <div class="col-md-4">
                  <label for="example-text-input" class="form-control-label">Teléfono</label>
                  <input class="form-control" type="text" v-model="user.persona.telefono" />
                </div>
              </div>
              <div class="col-md-12">
                <Checkbox v-model="changePassword" :binary="true" id="changePassword" />
                <label for="changePassword" class="mb-0 mt-4"> Cambiar Contraseña </label>
              </div>
              <!--  -->
              <div class="row py-2 mt-2" style="border: 2px solid #d3d3d3; border-radius: 20px;" v-if="changePassword">
                <div class="col-md-6">
                  <label for="password">Ingrese su contraseña nueva <span class="text-danger">*</span></label>
                  <Password v-model="reset.password" toggleMask class="w-100"
                    promptLabel="Eliga una contraseña" weakLabel="Muy simple" mediumLabel="Complejidad Media" strongLabel="Contraseña Compleja"
                  >
                    <template #header>
                        <h6>Eliga una contraseña</h6>
                        <b>La contraseña debe contener mínimamente 8 caracteres</b>
                    </template>
                    <template #footer>
                        <Divider />
                        <p class="mt-2">Sugerencias</p>
                        <ul class="pl-2 ml-2 mt-0" style="line-height: 1.5">
                            <li>Al menos una minúscula</li>
                            <li>Al menos una mayúscula</li>
                            <li>Al menos un número</li>
                            <!-- <li><b>Mínimamente 8 caracteres</b></li> -->
                        </ul>
                    </template>
                  </Password>
                  <InlineMessage severity="error" v-if="valueIsValid(reset.password) && reset.password.length < 8">La contraseña debe contener mínimamente 8 caracteres</InlineMessage>
                </div>
                <div class="col-md-6">
                  <label for="re-password">Confirme su contraseña nueva <span class="text-danger">*</span></label>
                  <Password v-model="reset.rePassword" toggleMask class="w-100" :feedback="false"/>
                  <InlineMessage severity="error" v-if="valueIsValid(reset.rePassword) && !resetIsValid">Las contraseñas no coinciden</InlineMessage>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 text-center">
                  <argon-button color="success" size="sm" class="ms-auto my-4" @click="editProfile" :disabled="!validUpdate">Actualizar</argon-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Toast></Toast>
    </div>
  </main>
</template>

<script>
import setNavPills from "@/assets/js/nav-pills.js";
import setTooltip from "@/assets/js/tooltip.js";
// import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import Password from 'primevue/password';
import InlineMessage from 'primevue/inlinemessage';
import Datepicker from 'vuejs3-datepicker';
import Checkbox from 'primevue/checkbox';
import axios from 'axios';
import authHeader from '../services/auth-header';
import Toast from 'primevue/toast';

const body = document.getElementsByTagName("body")[0];

export default {
  name: "profile",
  data() {
    return {
      showMenu: false,
      user: {
        nombre_rol: null,
        nombre_agencia: null,
        persona: {
          nombres: null,
          apellidos: null,
          email: null,
        }
      },
      reset: {
        visible: false,
        password: null,
        rePassword: null
      },
      changePassword: false,
      basicConfigDatePicker: {
        "language": "es",
        "full-month-name":true,
        "monday-first": true,
        "iconWidth": "18",
        "iconHeight": "18",
        "use-utc": true,
      },
    };
  },
  components: {
    Datepicker,
    Checkbox,
    ArgonButton,
    Password,
    InlineMessage,
    Toast
  },
  methods: {
    valueIsValid: function(value) {
      return (value !== null && value !== "" && value !== 0 && value !== [] && (typeof value !== "undefined"));
    },
    getUserDetail() {
      let profile = this.getProfileMe;
      if (profile == null &&  Object.keys(authHeader()).length !== 0) {
        let url = process.env.VUE_APP_API_BASE_URL + "/userDetail";
        axios({
          url: url,
          method: 'post',
          data: {},
          headers: authHeader(),
        })
        .then(response => {
          if (response.data.status) {
            this.user = response.data.data;
            this.menus = response.data.data.menu
            if (!this.user.logueado) {
              this.reset = {
                visible: true,
                password: null,
                rePassword: null
              };
            }
          }
        })
        .catch(error => {
          console.log("Error: " + error);
        });
      }
      if (profile != null) {
        this.menus = profile.data.menu;
      }
    },
    editProfile() {
      if (this.user.id_usuario == null) {
        this.$toast.add({ severity: 'error', summary: 'Error', detail: 'A ocurrido un error, datos no encontrados', life: 3000 });
        return true;
      }
      let payload = {
        "persona": {
            "nombres": this.user.persona.nombres,
            "apellidos": this.user.persona.apellidos,
            "fecha_nacimiento": this.user.persona.fecha_nacimiento,
            "numero_documento": this.user.persona.numero_documento,
            "telefono": this.user.persona.telefono,
            "email": this.user.persona.email,
        },
        "activo": true,
        "id_agencia": this.user.id_agencia,
        "id_rol": this.user.id_rol,
      }
      if (this.changePassword && this.resetIsValid) {
        payload.password = this.reset.password;
      }
      // Send Data by Axios
      let url = process.env.VUE_APP_API_BASE_URL + "/usuarios/" + this.user.id_usuario;
      axios({
        url: url,
        method: 'put',
        data: payload,
        headers: authHeader(),
      })
      .then(response => {
        if (response.data.status) {
            this.$toast.add({ severity: 'success', summary: 'Exito', detail: 'Sus datos fueron actualizados exitosamente', life: 3000 });
        } else {
          this.$toast.add({ severity: 'error', summary: 'Error', detail: 'No se pudo procesar su solicitud', life: 3000 });
        }
      })
      .catch(error => {
        console.log("Error: " + error);
      });
    },
  },
  computed: {
    resetIsValid() {
      return (this.valueIsValid(this.reset.password) && this.reset.password == this.reset.rePassword) ? true : false;
    },
    validUpdate() {
      let valid = true;
      if (this.changePassword) {
        if (!this.valueIsValid(this.reset.password) || this.reset.password != this.reset.rePassword) {
          valid = false;
        }
      }
      if (!this.valueIsValid(this.user.persona.nombres) || !this.valueIsValid(this.user.persona.apellidos) || !this.valueIsValid(this.user.persona.email)) {
        valid = false;
      }
      return valid;
    }
  },
  mounted() {
    this.$store.state.isAbsolute = true;
    this.getUserDetail();
    setNavPills();
    setTooltip();
  },
  beforeMount() {
    this.$store.state.imageLayout = "profile-overview";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = true;
    body.classList.add("profile-overview");
  },
  beforeUnmount() {
    this.$store.state.isAbsolute = false;
    this.$store.state.imageLayout = "default";
    this.$store.state.showNavbar = true;
    this.$store.state.showFooter = true;
    this.$store.state.hideConfigButton = false;
    body.classList.remove("profile-overview");
  }
};
</script>
